





































































































































import { Component, Vue } from 'vue-property-decorator'
import { Result } from '../../modules/RegisterResponseInfo'
import { getErrorMessage } from '../../modules/ErrorMessage'
import Drupal from '../../modules/Drupal'
import JsonUtil from '../../modules/JsonUtil'
import GetParameter from '../../modules/GetParameter'
import ErrorFormResponse from '../../modules/ErrorFormResponse'
import { post } from '../../modules/AxiosWrapper'
import { APIURL } from '../../modules/ApiUrl'

@Component
export default class PasswordRemindConfirm extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // data
  private updateDttm = ''
  private isComplate = false
  private isRemindUrl = false
  private gotoMyPage = ''
  private newPassword = ''
  private confirmPassword = ''
  private result: Result = 'error'
  private resultError: ErrorFormResponse = {}
  private uniqueCodeType = 'pwr'
  private isErrorMessageAreaVisible = false
  // -------------------------------------------------------------------------------------------------------------------
  // hocks
  private created() {
    this.clearData()
  }

  private beforeMount() {
    // マイページのURLを取得
    this.gotoMyPage = Drupal.member.pageUrl.myPage
  }

  private mounted() {
    // check url parameter
    this.initurlCheck()
  }
  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * エラーメッセージを空にする
   */
  private clearError() {
    this.resultError = {}
  }

  /**
   * データを空にする
   */
  private clearData() {
    this.updateDttm = ''
    this.isComplate = false
    this.newPassword = ''
    this.confirmPassword = ''
    this.resultError = {}
  }

  /**
   * パラメータの値を見て、サーバ側でURLの認証が正常に終了したか判断する
   * 認証失敗した場合はその旨のメッセージを画面に表示する
   */
  private async initurlCheck() {
    // get parameter
    const param = new GetParameter()
    param.setCurrentParam()

    const result = param.get('result')
    if (result === 'success') {
      this.clearError()
      this.isRemindUrl = true
      this.updateDttm = param.get('update_dttm')
    } else {
      this.isRemindUrl = false
      const errorCode = param.get('errorcode')
      const errorPreMsg = getErrorMessage(this.uniqueCodeType + errorCode)
      const errorMsg =
        errorPreMsg === 'not found' ? getErrorMessage('404') : errorPreMsg
      this.resultError.common = [errorMsg]
      this.isErrorMessageAreaVisible = true
    }
  }

  /**
   * 「設定する」ボタンをクリック
   *  APIにフォームに入力されたデータを送信する
   */
  private async passwordRemind() {
    this.isErrorMessageAreaVisible = false
    const form = JSON.stringify({
      new_password: this.newPassword,
      confirm_password: this.confirmPassword,
      update_dttm: this.updateDttm
    })

    const res = await post(APIURL.RemindFinish, form)
    if (res.status === 200) {
      this.result = res.data.result
      if (this.result === 'success') {
        // success password remind
        this.clearError()
        // show password change complate
        this.isComplate = true
      } else {
        // error password remind
        // show error message
        this.resultError = JsonUtil.jsonToObject<ErrorFormResponse>(
          ErrorFormResponse,
          res.data.errordata || {}
        )
        if (
          this.resultError.common !== undefined ||
          this.resultError.updateDttm !== undefined
        ) {
          this.isErrorMessageAreaVisible = true
        }
      }
    }
  }
}
